import { isInCapacitorPlatform } from '@fabric-app/compat/capabilities/platform';
import { IntegrationType } from '@fabric/woody-client';

const getDeviceType = () => isInCapacitorPlatform() ? isInCapacitorPlatform("capacitor-ios") ? IntegrationType.IOS_DEVICE : IntegrationType.ANDROID_DEVICE : null;

export { getDeviceType };
//# sourceMappingURL=connections.constants.js.map
